/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * Internal Monitoring API
 * Test internal monitoring description
 *
 * OpenAPI spec version: 0.1.DEV
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as url from "url";
import * as portableFetch from "portable-fetch";
import { Configuration } from "./configuration";

const BASE_PATH = "http://localhost:9000/internalMonitoring".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface FetchAPI
 */
export interface FetchAPI {
    (url: string, init?: any): Promise<Response>;
}

/**
 *  
 * @export
 * @interface FetchArgs
 */
export interface FetchArgs {
    url: string;
    options: any;
}

/**
 * 
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration | undefined;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected fetch: FetchAPI = portableFetch) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
};

/**
 * 
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    name: "RequiredError" = "RequiredError";
    constructor(public field: string, msg?: string) {
        super(msg);
    }
}

/**
 * 
 * @export
 * @interface CompanyMonitoringResult
 */
export interface CompanyMonitoringResult {
    /**
     * 
     * @type {string}
     * @memberof CompanyMonitoringResult
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyMonitoringResult
     */
    error?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyMonitoringResult
     */
    success?: boolean;
}

/**
 * 
 * @export
 * @interface CustomerReportResponse
 */
export interface CustomerReportResponse {
    /**
     * 
     * @type {EnrichedApiGatewayStatus}
     * @memberof CustomerReportResponse
     */
    apiGatewayStatus?: EnrichedApiGatewayStatus;
    /**
     * 
     * @type {EnrichedErrorFilesCountResponse}
     * @memberof CustomerReportResponse
     */
    errorFilesCount?: EnrichedErrorFilesCountResponse;
    /**
     * 
     * @type {EnrichedHealthResponseEtaCalculator}
     * @memberof CustomerReportResponse
     */
    etaCalculatorHealth?: EnrichedHealthResponseEtaCalculator;
    /**
     * 
     * @type {EnrichedFileSystemWorkerStatus}
     * @memberof CustomerReportResponse
     */
    fileSystemWorkerStatus?: EnrichedFileSystemWorkerStatus;
    /**
     * 
     * @type {EnrichedMessageLogReport}
     * @memberof CustomerReportResponse
     */
    messageLogHealth?: EnrichedMessageLogReport;
    /**
     * 
     * @type {EnrichedNeedsVerificationFilesCountResponse}
     * @memberof CustomerReportResponse
     */
    needsVerificationFilesCount?: EnrichedNeedsVerificationFilesCountResponse;
    /**
     * 
     * @type {EnrichedQueueStatus}
     * @memberof CustomerReportResponse
     */
    queueStatus?: EnrichedQueueStatus;
    /**
     * 
     * @type {EnrichedQueuedEventsErrorStatus}
     * @memberof CustomerReportResponse
     */
    queuedEventsErrorStatus?: EnrichedQueuedEventsErrorStatus;
    /**
     * 
     * @type {EnrichedSchedulerReportTaskStatus}
     * @memberof CustomerReportResponse
     */
    schedulerReportTaskStatus?: EnrichedSchedulerReportTaskStatus;
    /**
     * 
     * @type {EnrichedStatusJsonReport}
     * @memberof CustomerReportResponse
     */
    statusJsonReport?: EnrichedStatusJsonReport;
}

/**
 * 
 * @export
 * @interface DisableMonitoringRequest
 */
export interface DisableMonitoringRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof DisableMonitoringRequest
     */
    companyIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DisableMonitoringRequest
     */
    disabledBy?: string;
    /**
     * 
     * @type {string}
     * @memberof DisableMonitoringRequest
     */
    serviceType?: DisableMonitoringRequest.ServiceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DisableMonitoringRequest
     */
    state?: DisableMonitoringRequest.StateEnum;
}

/**
 * @export
 * @namespace DisableMonitoringRequest
 */
export namespace DisableMonitoringRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum ServiceTypeEnum {
        APIGATEWAYREPORT = 'API_GATEWAY_REPORT',
        SFTPREPORT = 'SFTP_REPORT',
        CUSTOMERFILEHEALTHREPORT = 'CUSTOMER_FILE_HEALTH_REPORT',
        LOGENIOSFILEHEALTHREPORT = 'LOGENIOS_FILE_HEALTH_REPORT',
        ATTACHMENTFILEHEALTHREPORT = 'ATTACHMENT_FILE_HEALTH_REPORT',
        QUEUEREPORT = 'QUEUE_REPORT',
        QUEUEERRORREPORT = 'QUEUE_ERROR_REPORT',
        STATUSJSONREPORT = 'STATUS_JSON_REPORT',
        NEEDSVERIFICATIONREPORT = 'NEEDS_VERIFICATION_REPORT',
        ERRORFILESREPORT = 'ERROR_FILES_REPORT',
        ETACALCULATORREPORT = 'ETA_CALCULATOR_REPORT',
        MESSAGELOGREPORT = 'MESSAGE_LOG_REPORT',
        SCHEDULERREPORTTASKSTATUS = 'SCHEDULER_REPORT_TASK_STATUS'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum StateEnum {
        ACK = 'ACK',
        IGNORE = 'IGNORE'
    }
}

/**
 * 
 * @export
 * @interface EnrichedApiGatewayStatus
 */
export interface EnrichedApiGatewayStatus {
    /**
     * 
     * @type {Array<EnrichedCompanyApiStatus>}
     * @memberof EnrichedApiGatewayStatus
     */
    companyApiStatus?: Array<EnrichedCompanyApiStatus>;
    /**
     * 
     * @type {number}
     * @memberof EnrichedApiGatewayStatus
     */
    totalPolledMessages?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrichedApiGatewayStatus
     */
    totalWaitingMessages?: number;
}

/**
 * 
 * @export
 * @interface EnrichedCompanyApiStatus
 */
export interface EnrichedCompanyApiStatus {
    /**
     * 
     * @type {ServiceMonitoringRecord}
     * @memberof EnrichedCompanyApiStatus
     */
    acknowledgementStatus?: ServiceMonitoringRecord;
    /**
     * 
     * @type {string}
     * @memberof EnrichedCompanyApiStatus
     */
    apiGatewayConfigsApi?: string;
    /**
     * 
     * @type {string}
     * @memberof EnrichedCompanyApiStatus
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof EnrichedCompanyApiStatus
     */
    companyName?: string;
    /**
     * 
     * @type {string}
     * @memberof EnrichedCompanyApiStatus
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof EnrichedCompanyApiStatus
     */
    errorMessage?: string;
    /**
     * 
     * @type {number}
     * @memberof EnrichedCompanyApiStatus
     */
    externalApiWaitingMessages?: number;
    /**
     * 
     * @type {ServiceMonitoringRecord}
     * @memberof EnrichedCompanyApiStatus
     */
    ignoreStatus?: ServiceMonitoringRecord;
    /**
     * 
     * @type {Date}
     * @memberof EnrichedCompanyApiStatus
     */
    lastRun?: Date;
    /**
     * 
     * @type {Date}
     * @memberof EnrichedCompanyApiStatus
     */
    lastSuccessfulRun?: Date;
    /**
     * 
     * @type {number}
     * @memberof EnrichedCompanyApiStatus
     */
    polledExternalApiMessages?: number;
    /**
     * 
     * @type {string}
     * @memberof EnrichedCompanyApiStatus
     */
    responsibleManager?: string;
    /**
     * 
     * @type {string}
     * @memberof EnrichedCompanyApiStatus
     */
    status?: EnrichedCompanyApiStatus.StatusEnum;
}

/**
 * @export
 * @namespace EnrichedCompanyApiStatus
 */
export namespace EnrichedCompanyApiStatus {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        OK = 'OK',
        WARNING = 'WARNING',
        ERROR = 'ERROR'
    }
}

/**
 * 
 * @export
 * @interface EnrichedCompanyMessageLogReport
 */
export interface EnrichedCompanyMessageLogReport {
    /**
     * 
     * @type {ServiceMonitoringRecord}
     * @memberof EnrichedCompanyMessageLogReport
     */
    acknowledgementStatus?: ServiceMonitoringRecord;
    /**
     * 
     * @type {string}
     * @memberof EnrichedCompanyMessageLogReport
     */
    companyId?: string;
    /**
     * 
     * @type {ServiceMonitoringRecord}
     * @memberof EnrichedCompanyMessageLogReport
     */
    ignoreStatus?: ServiceMonitoringRecord;
    /**
     * 
     * @type {string}
     * @memberof EnrichedCompanyMessageLogReport
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof EnrichedCompanyMessageLogReport
     */
    responsibleManager?: string;
    /**
     * 
     * @type {number}
     * @memberof EnrichedCompanyMessageLogReport
     */
    sendErrors?: number;
    /**
     * 
     * @type {string}
     * @memberof EnrichedCompanyMessageLogReport
     */
    tag?: string;
}

/**
 * 
 * @export
 * @interface EnrichedErrorFilesCountResponse
 */
export interface EnrichedErrorFilesCountResponse {
    /**
     * 
     * @type {Array<EnrichedErrorsFilesCountCompany>}
     * @memberof EnrichedErrorFilesCountResponse
     */
    companies?: Array<EnrichedErrorsFilesCountCompany>;
    /**
     * 
     * @type {number}
     * @memberof EnrichedErrorFilesCountResponse
     */
    filesOlderThanFiveMinutes?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EnrichedErrorFilesCountResponse
     */
    healthy?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EnrichedErrorFilesCountResponse
     */
    output?: string;
}

/**
 * 
 * @export
 * @interface EnrichedErrorsFilesCountCompany
 */
export interface EnrichedErrorsFilesCountCompany {
    /**
     * 
     * @type {ServiceMonitoringRecord}
     * @memberof EnrichedErrorsFilesCountCompany
     */
    acknowledgementStatus?: ServiceMonitoringRecord;
    /**
     * 
     * @type {string}
     * @memberof EnrichedErrorsFilesCountCompany
     */
    companyId?: string;
    /**
     * 
     * @type {number}
     * @memberof EnrichedErrorsFilesCountCompany
     */
    filesOlderThanFiveMinutes?: number;
    /**
     * 
     * @type {ServiceMonitoringRecord}
     * @memberof EnrichedErrorsFilesCountCompany
     */
    ignoreStatus?: ServiceMonitoringRecord;
    /**
     * 
     * @type {string}
     * @memberof EnrichedErrorsFilesCountCompany
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof EnrichedErrorsFilesCountCompany
     */
    oldestFileInMinutes?: number;
    /**
     * 
     * @type {string}
     * @memberof EnrichedErrorsFilesCountCompany
     */
    responsibleManager?: string;
    /**
     * 
     * @type {string}
     * @memberof EnrichedErrorsFilesCountCompany
     */
    tag?: string;
    /**
     * 
     * @type {number}
     * @memberof EnrichedErrorsFilesCountCompany
     */
    youngestFileInMinutes?: number;
}

/**
 * 
 * @export
 * @interface EnrichedFileSystemWorkerStatus
 */
export interface EnrichedFileSystemWorkerStatus {
    /**
     * 
     * @type {Array<EnrichedFtpFoldersFileHealth>}
     * @memberof EnrichedFileSystemWorkerStatus
     */
    attachmentOldFiles?: Array<EnrichedFtpFoldersFileHealth>;
    /**
     * 
     * @type {Array<EnrichedFtpFoldersFileHealth>}
     * @memberof EnrichedFileSystemWorkerStatus
     */
    customerOldFiles?: Array<EnrichedFtpFoldersFileHealth>;
    /**
     * 
     * @type {Array<EnrichedFtpFoldersFileHealth>}
     * @memberof EnrichedFileSystemWorkerStatus
     */
    logeniosOldFiles?: Array<EnrichedFtpFoldersFileHealth>;
    /**
     * 
     * @type {Array<EnrichedSftpSyncResult>}
     * @memberof EnrichedFileSystemWorkerStatus
     */
    sftpSyncResults?: Array<EnrichedSftpSyncResult>;
}

/**
 * 
 * @export
 * @interface EnrichedFtpFoldersFileHealth
 */
export interface EnrichedFtpFoldersFileHealth {
    /**
     * 
     * @type {ServiceMonitoringRecord}
     * @memberof EnrichedFtpFoldersFileHealth
     */
    acknowledgementStatus?: ServiceMonitoringRecord;
    /**
     * 
     * @type {string}
     * @memberof EnrichedFtpFoldersFileHealth
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof EnrichedFtpFoldersFileHealth
     */
    companyName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EnrichedFtpFoldersFileHealth
     */
    healthy?: boolean;
    /**
     * 
     * @type {ServiceMonitoringRecord}
     * @memberof EnrichedFtpFoldersFileHealth
     */
    ignoreStatus?: ServiceMonitoringRecord;
    /**
     * 
     * @type {number}
     * @memberof EnrichedFtpFoldersFileHealth
     */
    maxFileAgeBeforeWarningInSeconds?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrichedFtpFoldersFileHealth
     */
    oldFileAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof EnrichedFtpFoldersFileHealth
     */
    responsibleManager?: string;
}

/**
 * 
 * @export
 * @interface EnrichedHealthResponseEtaCalculator
 */
export interface EnrichedHealthResponseEtaCalculator {
    /**
     * 
     * @type {number}
     * @memberof EnrichedHealthResponseEtaCalculator
     */
    databaseQueueSize?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EnrichedHealthResponseEtaCalculator
     */
    isHealthy?: boolean;
    /**
     * 
     * @type {EnrichedOperatorHealth}
     * @memberof EnrichedHealthResponseEtaCalculator
     */
    operatorHealth?: EnrichedOperatorHealth;
    /**
     * 
     * @type {boolean}
     * @memberof EnrichedHealthResponseEtaCalculator
     */
    orsHealthy?: boolean;
    /**
     * 
     * @type {Array<EnrichedWorkerHealth>}
     * @memberof EnrichedHealthResponseEtaCalculator
     */
    workerThreads?: Array<EnrichedWorkerHealth>;
    /**
     * 
     * @type {boolean}
     * @memberof EnrichedHealthResponseEtaCalculator
     */
    workerThreadsHealthy?: boolean;
}

/**
 * 
 * @export
 * @interface EnrichedMessageLogReport
 */
export interface EnrichedMessageLogReport {
    /**
     * 
     * @type {Array<EnrichedCompanyMessageLogReport>}
     * @memberof EnrichedMessageLogReport
     */
    companies?: Array<EnrichedCompanyMessageLogReport>;
    /**
     * 
     * @type {number}
     * @memberof EnrichedMessageLogReport
     */
    totalSendErrors?: number;
}

/**
 * 
 * @export
 * @interface EnrichedNeedsVerificationFilesCountCompany
 */
export interface EnrichedNeedsVerificationFilesCountCompany {
    /**
     * 
     * @type {ServiceMonitoringRecord}
     * @memberof EnrichedNeedsVerificationFilesCountCompany
     */
    acknowledgementStatus?: ServiceMonitoringRecord;
    /**
     * 
     * @type {string}
     * @memberof EnrichedNeedsVerificationFilesCountCompany
     */
    companyId?: string;
    /**
     * 
     * @type {number}
     * @memberof EnrichedNeedsVerificationFilesCountCompany
     */
    filesOlderThanFiveMinutes?: number;
    /**
     * 
     * @type {ServiceMonitoringRecord}
     * @memberof EnrichedNeedsVerificationFilesCountCompany
     */
    ignoreStatus?: ServiceMonitoringRecord;
    /**
     * 
     * @type {string}
     * @memberof EnrichedNeedsVerificationFilesCountCompany
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof EnrichedNeedsVerificationFilesCountCompany
     */
    oldestFileInMinutes?: number;
    /**
     * 
     * @type {string}
     * @memberof EnrichedNeedsVerificationFilesCountCompany
     */
    responsibleManager?: string;
    /**
     * 
     * @type {string}
     * @memberof EnrichedNeedsVerificationFilesCountCompany
     */
    tag?: string;
}

/**
 * 
 * @export
 * @interface EnrichedNeedsVerificationFilesCountResponse
 */
export interface EnrichedNeedsVerificationFilesCountResponse {
    /**
     * 
     * @type {Array<EnrichedNeedsVerificationFilesCountCompany>}
     * @memberof EnrichedNeedsVerificationFilesCountResponse
     */
    companies?: Array<EnrichedNeedsVerificationFilesCountCompany>;
    /**
     * 
     * @type {number}
     * @memberof EnrichedNeedsVerificationFilesCountResponse
     */
    filesOlderThanFiveMinutes?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EnrichedNeedsVerificationFilesCountResponse
     */
    healthy?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EnrichedNeedsVerificationFilesCountResponse
     */
    output?: string;
}

/**
 * 
 * @export
 * @interface EnrichedOperatorHealth
 */
export interface EnrichedOperatorHealth {
    /**
     * 
     * @type {boolean}
     * @memberof EnrichedOperatorHealth
     */
    isHealthy?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof EnrichedOperatorHealth
     */
    lastActivity?: Date;
    /**
     * 
     * @type {string}
     * @memberof EnrichedOperatorHealth
     */
    lastConfigFetch?: string;
}

/**
 * 
 * @export
 * @interface EnrichedQueueStatus
 */
export interface EnrichedQueueStatus {
    /**
     * 
     * @type {Array<EnrichedQueuedEventsHealthCompanyReport>}
     * @memberof EnrichedQueueStatus
     */
    companies?: Array<EnrichedQueuedEventsHealthCompanyReport>;
}

/**
 * 
 * @export
 * @interface EnrichedQueuedEventsErrorCompanyReport
 */
export interface EnrichedQueuedEventsErrorCompanyReport {
    /**
     * 
     * @type {ServiceMonitoringRecord}
     * @memberof EnrichedQueuedEventsErrorCompanyReport
     */
    acknowledgementStatus?: ServiceMonitoringRecord;
    /**
     * 
     * @type {string}
     * @memberof EnrichedQueuedEventsErrorCompanyReport
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof EnrichedQueuedEventsErrorCompanyReport
     */
    errorSummary?: string;
    /**
     * 
     * @type {ServiceMonitoringRecord}
     * @memberof EnrichedQueuedEventsErrorCompanyReport
     */
    ignoreStatus?: ServiceMonitoringRecord;
    /**
     * 
     * @type {string}
     * @memberof EnrichedQueuedEventsErrorCompanyReport
     */
    name?: string;
    /**
     * 
     * @type {Date}
     * @memberof EnrichedQueuedEventsErrorCompanyReport
     */
    oldestErrorEventFrom?: Date;
    /**
     * 
     * @type {number}
     * @memberof EnrichedQueuedEventsErrorCompanyReport
     */
    processedEventsWithErrorCount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof EnrichedQueuedEventsErrorCompanyReport
     */
    recentErrorEventIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof EnrichedQueuedEventsErrorCompanyReport
     */
    responsibleManager?: string;
}

/**
 * 
 * @export
 * @interface EnrichedQueuedEventsErrorStatus
 */
export interface EnrichedQueuedEventsErrorStatus {
    /**
     * 
     * @type {Array<EnrichedQueuedEventsErrorCompanyReport>}
     * @memberof EnrichedQueuedEventsErrorStatus
     */
    companies?: Array<EnrichedQueuedEventsErrorCompanyReport>;
}

/**
 * 
 * @export
 * @interface EnrichedQueuedEventsHealthCompanyReport
 */
export interface EnrichedQueuedEventsHealthCompanyReport {
    /**
     * 
     * @type {ServiceMonitoringRecord}
     * @memberof EnrichedQueuedEventsHealthCompanyReport
     */
    acknowledgementStatus?: ServiceMonitoringRecord;
    /**
     * 
     * @type {string}
     * @memberof EnrichedQueuedEventsHealthCompanyReport
     */
    companyId?: string;
    /**
     * 
     * @type {ServiceMonitoringRecord}
     * @memberof EnrichedQueuedEventsHealthCompanyReport
     */
    ignoreStatus?: ServiceMonitoringRecord;
    /**
     * 
     * @type {string}
     * @memberof EnrichedQueuedEventsHealthCompanyReport
     */
    name?: string;
    /**
     * 
     * @type {Date}
     * @memberof EnrichedQueuedEventsHealthCompanyReport
     */
    oldestUnprocessedEventFrom?: Date;
    /**
     * 
     * @type {Array<string>}
     * @memberof EnrichedQueuedEventsHealthCompanyReport
     */
    oldestUnprocessedEventIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof EnrichedQueuedEventsHealthCompanyReport
     */
    responsibleManager?: string;
    /**
     * 
     * @type {number}
     * @memberof EnrichedQueuedEventsHealthCompanyReport
     */
    unprocessedEventsOlderThanFiveMinutes?: number;
}

/**
 * 
 * @export
 * @interface EnrichedSchedulerReportTaskCompanyStatus
 */
export interface EnrichedSchedulerReportTaskCompanyStatus {
    /**
     * 
     * @type {ServiceMonitoringRecord}
     * @memberof EnrichedSchedulerReportTaskCompanyStatus
     */
    acknowledgementStatus?: ServiceMonitoringRecord;
    /**
     * 
     * @type {string}
     * @memberof EnrichedSchedulerReportTaskCompanyStatus
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof EnrichedSchedulerReportTaskCompanyStatus
     */
    companyName?: string;
    /**
     * 
     * @type {ServiceMonitoringRecord}
     * @memberof EnrichedSchedulerReportTaskCompanyStatus
     */
    ignoreStatus?: ServiceMonitoringRecord;
    /**
     * 
     * @type {string}
     * @memberof EnrichedSchedulerReportTaskCompanyStatus
     */
    responsibleManager?: string;
    /**
     * 
     * @type {Array<SchedulerReportingConfiguration>}
     * @memberof EnrichedSchedulerReportTaskCompanyStatus
     */
    tasks?: Array<SchedulerReportingConfiguration>;
    /**
     * 
     * @type {number}
     * @memberof EnrichedSchedulerReportTaskCompanyStatus
     */
    unhealthyTasks?: number;
}

/**
 * 
 * @export
 * @interface EnrichedSchedulerReportTaskStatus
 */
export interface EnrichedSchedulerReportTaskStatus {
    /**
     * 
     * @type {Array<EnrichedSchedulerReportTaskCompanyStatus>}
     * @memberof EnrichedSchedulerReportTaskStatus
     */
    companies?: Array<EnrichedSchedulerReportTaskCompanyStatus>;
    /**
     * 
     * @type {boolean}
     * @memberof EnrichedSchedulerReportTaskStatus
     */
    healthy?: boolean;
}

/**
 * 
 * @export
 * @interface EnrichedSftpSyncResult
 */
export interface EnrichedSftpSyncResult {
    /**
     * 
     * @type {ServiceMonitoringRecord}
     * @memberof EnrichedSftpSyncResult
     */
    acknowledgementStatus?: ServiceMonitoringRecord;
    /**
     * 
     * @type {string}
     * @memberof EnrichedSftpSyncResult
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof EnrichedSftpSyncResult
     */
    icingaState?: string;
    /**
     * 
     * @type {ServiceMonitoringRecord}
     * @memberof EnrichedSftpSyncResult
     */
    ignoreStatus?: ServiceMonitoringRecord;
    /**
     * 
     * @type {string}
     * @memberof EnrichedSftpSyncResult
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof EnrichedSftpSyncResult
     */
    responsibleManager?: string;
    /**
     * 
     * @type {string}
     * @memberof EnrichedSftpSyncResult
     */
    status?: EnrichedSftpSyncResult.StatusEnum;
    /**
     * 
     * @type {number}
     * @memberof EnrichedSftpSyncResult
     */
    successfulRuns?: number;
    /**
     * 
     * @type {Date}
     * @memberof EnrichedSftpSyncResult
     */
    timestamp?: Date;
}

/**
 * @export
 * @namespace EnrichedSftpSyncResult
 */
export namespace EnrichedSftpSyncResult {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        SUCCESS = 'SUCCESS',
        ERROR = 'ERROR'
    }
}

/**
 * 
 * @export
 * @interface EnrichedStatusJsonReport
 */
export interface EnrichedStatusJsonReport {
    /**
     * 
     * @type {Array<EnrichedStatusJsonReportCompany>}
     * @memberof EnrichedStatusJsonReport
     */
    companies?: Array<EnrichedStatusJsonReportCompany>;
    /**
     * 
     * @type {number}
     * @memberof EnrichedStatusJsonReport
     */
    companiesMissingStatusJsonFile?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrichedStatusJsonReport
     */
    companiesWithLastRunOld?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrichedStatusJsonReport
     */
    companiesWithoutRecentFileUpdate?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrichedStatusJsonReport
     */
    totalCompaniesChecked?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrichedStatusJsonReport
     */
    unhealthyCompanies?: number;
}

/**
 * 
 * @export
 * @interface EnrichedStatusJsonReportCompany
 */
export interface EnrichedStatusJsonReportCompany {
    /**
     * 
     * @type {ServiceMonitoringRecord}
     * @memberof EnrichedStatusJsonReportCompany
     */
    acknowledgementStatus?: ServiceMonitoringRecord;
    /**
     * 
     * @type {string}
     * @memberof EnrichedStatusJsonReportCompany
     */
    checkMode?: string;
    /**
     * 
     * @type {string}
     * @memberof EnrichedStatusJsonReportCompany
     */
    companyId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EnrichedStatusJsonReportCompany
     */
    healthy?: boolean;
    /**
     * 
     * @type {ServiceMonitoringRecord}
     * @memberof EnrichedStatusJsonReportCompany
     */
    ignoreStatus?: ServiceMonitoringRecord;
    /**
     * 
     * @type {Date}
     * @memberof EnrichedStatusJsonReportCompany
     */
    lastFileUpdate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof EnrichedStatusJsonReportCompany
     */
    lastFileUpdateTooOld?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof EnrichedStatusJsonReportCompany
     */
    lastRun?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof EnrichedStatusJsonReportCompany
     */
    lastRunTooOld?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EnrichedStatusJsonReportCompany
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof EnrichedStatusJsonReportCompany
     */
    otherError?: string;
    /**
     * 
     * @type {string}
     * @memberof EnrichedStatusJsonReportCompany
     */
    responsibleManager?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EnrichedStatusJsonReportCompany
     */
    statusJsonExists?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EnrichedStatusJsonReportCompany
     */
    statusLine?: string;
    /**
     * 
     * @type {string}
     * @memberof EnrichedStatusJsonReportCompany
     */
    tag?: string;
}

/**
 * 
 * @export
 * @interface EnrichedWorkerHealth
 */
export interface EnrichedWorkerHealth {
    /**
     * 
     * @type {ServiceMonitoringRecord}
     * @memberof EnrichedWorkerHealth
     */
    acknowledgementStatus?: ServiceMonitoringRecord;
    /**
     * 
     * @type {string}
     * @memberof EnrichedWorkerHealth
     */
    companyId?: string;
    /**
     * 
     * @type {ServiceMonitoringRecord}
     * @memberof EnrichedWorkerHealth
     */
    ignoreStatus?: ServiceMonitoringRecord;
    /**
     * 
     * @type {boolean}
     * @memberof EnrichedWorkerHealth
     */
    isHealthy?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof EnrichedWorkerHealth
     */
    lastActivity?: Date;
    /**
     * 
     * @type {string}
     * @memberof EnrichedWorkerHealth
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof EnrichedWorkerHealth
     */
    numErrorsInLastCycle?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrichedWorkerHealth
     */
    numUnprocessedEvents?: number;
    /**
     * 
     * @type {string}
     * @memberof EnrichedWorkerHealth
     */
    responsibleManager?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EnrichedWorkerHealth
     */
    wasActive?: boolean;
}

/**
 * Arbitrary key value pairs
 * @export
 * @interface HashMap
 */
export interface HashMap {
}

/**
 * 
 * @export
 * @interface MonitoringCompaniesResponse
 */
export interface MonitoringCompaniesResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof MonitoringCompaniesResponse
     */
    companyIds?: Array<string>;
}

/**
 * 
 * @export
 * @interface MonitoringRecordRequest
 */
export interface MonitoringRecordRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof MonitoringRecordRequest
     */
    companyIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MonitoringRecordRequest
     */
    createdBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof MonitoringRecordRequest
     */
    fromDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof MonitoringRecordRequest
     */
    reason?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitoringRecordRequest
     */
    serviceType?: MonitoringRecordRequest.ServiceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MonitoringRecordRequest
     */
    state?: MonitoringRecordRequest.StateEnum;
    /**
     * 
     * @type {string}
     * @memberof MonitoringRecordRequest
     */
    untilChangeResult?: string;
    /**
     * 
     * @type {Date}
     * @memberof MonitoringRecordRequest
     */
    untilDate?: Date;
}

/**
 * @export
 * @namespace MonitoringRecordRequest
 */
export namespace MonitoringRecordRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum ServiceTypeEnum {
        APIGATEWAYREPORT = 'API_GATEWAY_REPORT',
        SFTPREPORT = 'SFTP_REPORT',
        CUSTOMERFILEHEALTHREPORT = 'CUSTOMER_FILE_HEALTH_REPORT',
        LOGENIOSFILEHEALTHREPORT = 'LOGENIOS_FILE_HEALTH_REPORT',
        ATTACHMENTFILEHEALTHREPORT = 'ATTACHMENT_FILE_HEALTH_REPORT',
        QUEUEREPORT = 'QUEUE_REPORT',
        QUEUEERRORREPORT = 'QUEUE_ERROR_REPORT',
        STATUSJSONREPORT = 'STATUS_JSON_REPORT',
        NEEDSVERIFICATIONREPORT = 'NEEDS_VERIFICATION_REPORT',
        ERRORFILESREPORT = 'ERROR_FILES_REPORT',
        ETACALCULATORREPORT = 'ETA_CALCULATOR_REPORT',
        MESSAGELOGREPORT = 'MESSAGE_LOG_REPORT',
        SCHEDULERREPORTTASKSTATUS = 'SCHEDULER_REPORT_TASK_STATUS'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum StateEnum {
        ACK = 'ACK',
        IGNORE = 'IGNORE'
    }
}

/**
 * 
 * @export
 * @interface MonitoringRecordResponse
 */
export interface MonitoringRecordResponse {
    /**
     * 
     * @type {string}
     * @memberof MonitoringRecordResponse
     */
    error?: string;
    /**
     * 
     * @type {Array<CompanyMonitoringResult>}
     * @memberof MonitoringRecordResponse
     */
    results?: Array<CompanyMonitoringResult>;
    /**
     * 
     * @type {boolean}
     * @memberof MonitoringRecordResponse
     */
    success?: boolean;
}

/**
 * 
 * @export
 * @interface MonitoringRecordsResponse
 */
export interface MonitoringRecordsResponse {
    /**
     * 
     * @type {Array<ServiceMonitoringRecord>}
     * @memberof MonitoringRecordsResponse
     */
    records?: Array<ServiceMonitoringRecord>;
}

/**
 * 
 * @export
 * @interface MonitoringServiceStatus
 */
export interface MonitoringServiceStatus {
    /**
     * 
     * @type {ServiceMonitoringRecord}
     * @memberof MonitoringServiceStatus
     */
    serviceMonitoringRecord?: ServiceMonitoringRecord;
    /**
     * 
     * @type {string}
     * @memberof MonitoringServiceStatus
     */
    serviceType?: MonitoringServiceStatus.ServiceTypeEnum;
}

/**
 * @export
 * @namespace MonitoringServiceStatus
 */
export namespace MonitoringServiceStatus {
    /**
     * @export
     * @enum {string}
     */
    export enum ServiceTypeEnum {
        APIGATEWAYREPORT = 'API_GATEWAY_REPORT',
        SFTPREPORT = 'SFTP_REPORT',
        CUSTOMERFILEHEALTHREPORT = 'CUSTOMER_FILE_HEALTH_REPORT',
        LOGENIOSFILEHEALTHREPORT = 'LOGENIOS_FILE_HEALTH_REPORT',
        ATTACHMENTFILEHEALTHREPORT = 'ATTACHMENT_FILE_HEALTH_REPORT',
        QUEUEREPORT = 'QUEUE_REPORT',
        QUEUEERRORREPORT = 'QUEUE_ERROR_REPORT',
        STATUSJSONREPORT = 'STATUS_JSON_REPORT',
        NEEDSVERIFICATIONREPORT = 'NEEDS_VERIFICATION_REPORT',
        ERRORFILESREPORT = 'ERROR_FILES_REPORT',
        ETACALCULATORREPORT = 'ETA_CALCULATOR_REPORT',
        MESSAGELOGREPORT = 'MESSAGE_LOG_REPORT',
        SCHEDULERREPORTTASKSTATUS = 'SCHEDULER_REPORT_TASK_STATUS'
    }
}

/**
 * 
 * @export
 * @interface MonitoringStatusResponse
 */
export interface MonitoringStatusResponse {
    /**
     * 
     * @type {string}
     * @memberof MonitoringStatusResponse
     */
    companyId?: string;
    /**
     * 
     * @type {Array<MonitoringServiceStatus>}
     * @memberof MonitoringStatusResponse
     */
    currentStatus?: Array<MonitoringServiceStatus>;
}

/**
 * 
 * @export
 * @interface OffsetDateTime
 */
export interface OffsetDateTime {
    /**
     * 
     * @type {Date}
     * @memberof OffsetDateTime
     */
    dateTime?: Date;
    /**
     * 
     * @type {ZoneOffset}
     * @memberof OffsetDateTime
     */
    offset?: ZoneOffset;
}

/**
 * 
 * @export
 * @interface ProcessUntilChangeResponse
 */
export interface ProcessUntilChangeResponse {
    /**
     * 
     * @type {number}
     * @memberof ProcessUntilChangeResponse
     */
    disabledCount?: number;
    /**
     * 
     * @type {string}
     * @memberof ProcessUntilChangeResponse
     */
    error?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProcessUntilChangeResponse
     */
    success?: boolean;
}

/**
 * 
 * @export
 * @interface SchedulerReportingConfiguration
 */
export interface SchedulerReportingConfiguration {
    /**
     * 
     * @type {string}
     * @memberof SchedulerReportingConfiguration
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SchedulerReportingConfiguration
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof SchedulerReportingConfiguration
     */
    displayName?: string;
    /**
     * 
     * @type {OffsetDateTime}
     * @memberof SchedulerReportingConfiguration
     */
    lastExecution?: OffsetDateTime;
    /**
     * 
     * @type {OffsetDateTime}
     * @memberof SchedulerReportingConfiguration
     */
    nextExecution?: OffsetDateTime;
    /**
     * 
     * @type {string}
     * @memberof SchedulerReportingConfiguration
     */
    reportName?: SchedulerReportingConfiguration.ReportNameEnum;
    /**
     * 
     * @type {string}
     * @memberof SchedulerReportingConfiguration
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof SchedulerReportingConfiguration
     */
    timeZone?: string;
    /**
     * 
     * @type {string}
     * @memberof SchedulerReportingConfiguration
     */
    xRequestId?: string;
}

/**
 * @export
 * @namespace SchedulerReportingConfiguration
 */
export namespace SchedulerReportingConfiguration {
    /**
     * @export
     * @enum {string}
     */
    export enum ReportNameEnum {
        ELFLEINVDLREPORT = 'ELFLEIN_VDL_REPORT',
        ELFLEINVDLERRORREPORT = 'ELFLEIN_VDL_ERROR_REPORT',
        REPORTV2 = 'REPORT_V2',
        STANDINGTIMESREPORT = 'STANDING_TIMES_REPORT',
        DELIVERYREPORT = 'DELIVERY_REPORT'
    }
}

/**
 * 
 * @export
 * @interface ServiceMonitoringRecord
 */
export interface ServiceMonitoringRecord {
    /**
     * 
     * @type {string}
     * @memberof ServiceMonitoringRecord
     */
    _id?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceMonitoringRecord
     */
    companyId?: string;
    /**
     * 
     * @type {Date}
     * @memberof ServiceMonitoringRecord
     */
    createdAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof ServiceMonitoringRecord
     */
    createdBy?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ServiceMonitoringRecord
     */
    enabled?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ServiceMonitoringRecord
     */
    fromDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof ServiceMonitoringRecord
     */
    reason?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceMonitoringRecord
     */
    serviceType?: ServiceMonitoringRecord.ServiceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ServiceMonitoringRecord
     */
    state?: ServiceMonitoringRecord.StateEnum;
    /**
     * 
     * @type {string}
     * @memberof ServiceMonitoringRecord
     */
    untilChangeResult?: string;
    /**
     * 
     * @type {Date}
     * @memberof ServiceMonitoringRecord
     */
    untilDate?: Date;
}

/**
 * @export
 * @namespace ServiceMonitoringRecord
 */
export namespace ServiceMonitoringRecord {
    /**
     * @export
     * @enum {string}
     */
    export enum ServiceTypeEnum {
        APIGATEWAYREPORT = 'API_GATEWAY_REPORT',
        SFTPREPORT = 'SFTP_REPORT',
        CUSTOMERFILEHEALTHREPORT = 'CUSTOMER_FILE_HEALTH_REPORT',
        LOGENIOSFILEHEALTHREPORT = 'LOGENIOS_FILE_HEALTH_REPORT',
        ATTACHMENTFILEHEALTHREPORT = 'ATTACHMENT_FILE_HEALTH_REPORT',
        QUEUEREPORT = 'QUEUE_REPORT',
        QUEUEERRORREPORT = 'QUEUE_ERROR_REPORT',
        STATUSJSONREPORT = 'STATUS_JSON_REPORT',
        NEEDSVERIFICATIONREPORT = 'NEEDS_VERIFICATION_REPORT',
        ERRORFILESREPORT = 'ERROR_FILES_REPORT',
        ETACALCULATORREPORT = 'ETA_CALCULATOR_REPORT',
        MESSAGELOGREPORT = 'MESSAGE_LOG_REPORT',
        SCHEDULERREPORTTASKSTATUS = 'SCHEDULER_REPORT_TASK_STATUS'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum StateEnum {
        ACK = 'ACK',
        IGNORE = 'IGNORE'
    }
}

/**
 * 
 * @export
 * @interface ZoneOffset
 */
export interface ZoneOffset {
    /**
     * 
     * @type {number}
     * @memberof ZoneOffset
     */
    totalSeconds?: number;
    /**
     * 
     * @type {string}
     * @memberof ZoneOffset
     */
    id?: string;
}


/**
 * InternalMonitoringApi - fetch parameter creator
 * @export
 */
export const InternalMonitoringApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Adds monitoring records for multiple companies and a single service type. This endpoint allows acknowledging or ignoring monitoring alerts for specific services. Supports both single company (list with one item) and multiple companies.
         * @summary add monitoring record
         * @param {MonitoringRecordRequest} MonitoringRecordRequest MonitoringRecordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMonitoringRecord(MonitoringRecordRequest: MonitoringRecordRequest, options: any = {}): FetchArgs {
            // verify required parameter 'MonitoringRecordRequest' is not null or undefined
            if (MonitoringRecordRequest === null || MonitoringRecordRequest === undefined) {
                throw new RequiredError('MonitoringRecordRequest','Required parameter MonitoringRecordRequest was null or undefined when calling addMonitoringRecord.');
            }
            const localVarPath = `/customerReport/monitoring/record`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MonitoringRecordRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(MonitoringRecordRequest || {}) : (MonitoringRecordRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Disables monitoring for multiple companies and a single service type. This endpoint allows unacknowledging or unignoring monitoring alerts. Supports both single company (list with one item) and multiple companies.
         * @summary disable monitoring
         * @param {DisableMonitoringRequest} DisableMonitoringRequest DisableMonitoringRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableMonitoring(DisableMonitoringRequest: DisableMonitoringRequest, options: any = {}): FetchArgs {
            // verify required parameter 'DisableMonitoringRequest' is not null or undefined
            if (DisableMonitoringRequest === null || DisableMonitoringRequest === undefined) {
                throw new RequiredError('DisableMonitoringRequest','Required parameter DisableMonitoringRequest was null or undefined when calling disableMonitoring.');
            }
            const localVarPath = `/customerReport/monitoring/disable`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"DisableMonitoringRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(DisableMonitoringRequest || {}) : (DisableMonitoringRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all companies that have monitoring configuration. This endpoint provides a list of companies with active monitoring setup.
         * @summary get all companies with monitoring
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCompaniesWithMonitoring(options: any = {}): FetchArgs {
            const localVarPath = `/customerReport/monitoring/companies`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the current customer report containing health status of all monitored services. This endpoint provides a comprehensive overview of system health including API gateway status, file system worker status, queue status, and other critical service metrics.
         * @summary get customer report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerReport(options: any = {}): FetchArgs {
            const localVarPath = `/customerReport`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the customer report filtered for Icinga monitoring system. This endpoint excludes companies that are marked as ignored in the monitoring configuration.
         * @summary get customer report filtered for Icinga
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerReportFilteredForIcinga(options: any = {}): FetchArgs {
            const localVarPath = `/customerReport/filteredForIcinga`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the customer report filtered to show only data for the authenticated user's company. This endpoint provides company-specific monitoring data based on the user's authentication context.
         * @summary get customer report for my company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerReportForMyCompany(options: any = {}): FetchArgs {
            const localVarPath = `/customerReport/onlyMyCompany`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all monitoring records (history) for a specific company. This endpoint provides a complete audit trail of monitoring actions.
         * @summary get monitoring records for company
         * @param {string} companyId companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonitoringRecordsForCompany(companyId: string, options: any = {}): FetchArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling getMonitoringRecordsForCompany.');
            }
            const localVarPath = `/customerReport/monitoring/records/{companyId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the current monitoring status for all services of a specific company. This endpoint provides a comprehensive view of monitoring state for a company.
         * @summary get monitoring status for company
         * @param {string} companyId companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonitoringStatusForCompany(companyId: string, options: any = {}): FetchArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling getMonitoringStatusForCompany.');
            }
            const localVarPath = `/customerReport/monitoring/status/{companyId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a specific section of the customer report based on the report type. Available report types: apiGatewayStatus, fileSystemWorkerStatus, queueStatus,  statusJsonReport, needsVerificationFilesCount, errorFilesCount, etaCalculatorHealth,  messageLogHealth, schedulerReportTaskStatus.
         * @summary get specific customer report section
         * @param {string} specificReport specificReport
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpecificCustomerReport(specificReport: string, options: any = {}): FetchArgs {
            // verify required parameter 'specificReport' is not null or undefined
            if (specificReport === null || specificReport === undefined) {
                throw new RequiredError('specificReport','Required parameter specificReport was null or undefined when calling getSpecificCustomerReport.');
            }
            const localVarPath = `/customerReport/{specificReport}`
                .replace(`{${"specificReport"}}`, encodeURIComponent(String(specificReport)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns only unhealthy companies that are not ignored for Icinga monitoring. This endpoint provides a focused view of companies requiring attention.
         * @summary get unhealthy companies for Icinga
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnhealthyCompaniesForIcinga(options: any = {}): FetchArgs {
            const localVarPath = `/customerReport/filteredUnHealthyAndUnIgnoredForIcinga`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the customer report after performing a fresh health check. This endpoint triggers a health check before returning the report, ensuring the most current status.
         * @summary get updated customer report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUpdatedCustomerReport(options: any = {}): FetchArgs {
            const localVarPath = `/customerReport/updated`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Processes all \"until change\" conditions for active monitoring records. This endpoint checks if any monitoring records should be disabled based on change detection logic and disables them automatically.
         * @summary process until change conditions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processUntilChangeConditions(options: any = {}): FetchArgs {
            const localVarPath = `/customerReport/monitoring/processUntilChange`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }

            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InternalMonitoringApi - functional programming interface
 * @export
 */
export const InternalMonitoringApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Adds monitoring records for multiple companies and a single service type. This endpoint allows acknowledging or ignoring monitoring alerts for specific services. Supports both single company (list with one item) and multiple companies.
         * @summary add monitoring record
         * @param {MonitoringRecordRequest} MonitoringRecordRequest MonitoringRecordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMonitoringRecord(MonitoringRecordRequest: MonitoringRecordRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MonitoringRecordResponse> {
            const localVarFetchArgs = InternalMonitoringApiFetchParamCreator(configuration).addMonitoringRecord(MonitoringRecordRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Disables monitoring for multiple companies and a single service type. This endpoint allows unacknowledging or unignoring monitoring alerts. Supports both single company (list with one item) and multiple companies.
         * @summary disable monitoring
         * @param {DisableMonitoringRequest} DisableMonitoringRequest DisableMonitoringRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableMonitoring(DisableMonitoringRequest: DisableMonitoringRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MonitoringRecordResponse> {
            const localVarFetchArgs = InternalMonitoringApiFetchParamCreator(configuration).disableMonitoring(DisableMonitoringRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns all companies that have monitoring configuration. This endpoint provides a list of companies with active monitoring setup.
         * @summary get all companies with monitoring
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCompaniesWithMonitoring(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MonitoringCompaniesResponse> {
            const localVarFetchArgs = InternalMonitoringApiFetchParamCreator(configuration).getAllCompaniesWithMonitoring(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns the current customer report containing health status of all monitored services. This endpoint provides a comprehensive overview of system health including API gateway status, file system worker status, queue status, and other critical service metrics.
         * @summary get customer report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerReport(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CustomerReportResponse> {
            const localVarFetchArgs = InternalMonitoringApiFetchParamCreator(configuration).getCustomerReport(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns the customer report filtered for Icinga monitoring system. This endpoint excludes companies that are marked as ignored in the monitoring configuration.
         * @summary get customer report filtered for Icinga
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerReportFilteredForIcinga(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CustomerReportResponse> {
            const localVarFetchArgs = InternalMonitoringApiFetchParamCreator(configuration).getCustomerReportFilteredForIcinga(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns the customer report filtered to show only data for the authenticated user's company. This endpoint provides company-specific monitoring data based on the user's authentication context.
         * @summary get customer report for my company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerReportForMyCompany(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CustomerReportResponse> {
            const localVarFetchArgs = InternalMonitoringApiFetchParamCreator(configuration).getCustomerReportForMyCompany(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns all monitoring records (history) for a specific company. This endpoint provides a complete audit trail of monitoring actions.
         * @summary get monitoring records for company
         * @param {string} companyId companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonitoringRecordsForCompany(companyId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MonitoringRecordsResponse> {
            const localVarFetchArgs = InternalMonitoringApiFetchParamCreator(configuration).getMonitoringRecordsForCompany(companyId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns the current monitoring status for all services of a specific company. This endpoint provides a comprehensive view of monitoring state for a company.
         * @summary get monitoring status for company
         * @param {string} companyId companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonitoringStatusForCompany(companyId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MonitoringStatusResponse> {
            const localVarFetchArgs = InternalMonitoringApiFetchParamCreator(configuration).getMonitoringStatusForCompany(companyId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns a specific section of the customer report based on the report type. Available report types: apiGatewayStatus, fileSystemWorkerStatus, queueStatus,  statusJsonReport, needsVerificationFilesCount, errorFilesCount, etaCalculatorHealth,  messageLogHealth, schedulerReportTaskStatus.
         * @summary get specific customer report section
         * @param {string} specificReport specificReport
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpecificCustomerReport(specificReport: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CustomerReportResponse> {
            const localVarFetchArgs = InternalMonitoringApiFetchParamCreator(configuration).getSpecificCustomerReport(specificReport, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns only unhealthy companies that are not ignored for Icinga monitoring. This endpoint provides a focused view of companies requiring attention.
         * @summary get unhealthy companies for Icinga
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnhealthyCompaniesForIcinga(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CustomerReportResponse> {
            const localVarFetchArgs = InternalMonitoringApiFetchParamCreator(configuration).getUnhealthyCompaniesForIcinga(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns the customer report after performing a fresh health check. This endpoint triggers a health check before returning the report, ensuring the most current status.
         * @summary get updated customer report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUpdatedCustomerReport(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CustomerReportResponse> {
            const localVarFetchArgs = InternalMonitoringApiFetchParamCreator(configuration).getUpdatedCustomerReport(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Processes all \"until change\" conditions for active monitoring records. This endpoint checks if any monitoring records should be disabled based on change detection logic and disables them automatically.
         * @summary process until change conditions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processUntilChangeConditions(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ProcessUntilChangeResponse> {
            const localVarFetchArgs = InternalMonitoringApiFetchParamCreator(configuration).processUntilChangeConditions(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * InternalMonitoringApi - factory interface
 * @export
 */
export const InternalMonitoringApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Adds monitoring records for multiple companies and a single service type. This endpoint allows acknowledging or ignoring monitoring alerts for specific services. Supports both single company (list with one item) and multiple companies.
         * @summary add monitoring record
         * @param {MonitoringRecordRequest} MonitoringRecordRequest MonitoringRecordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMonitoringRecord(MonitoringRecordRequest: MonitoringRecordRequest, options?: any) {
            return InternalMonitoringApiFp(configuration).addMonitoringRecord(MonitoringRecordRequest, options)(fetch, basePath);
        },
        /**
         * Disables monitoring for multiple companies and a single service type. This endpoint allows unacknowledging or unignoring monitoring alerts. Supports both single company (list with one item) and multiple companies.
         * @summary disable monitoring
         * @param {DisableMonitoringRequest} DisableMonitoringRequest DisableMonitoringRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableMonitoring(DisableMonitoringRequest: DisableMonitoringRequest, options?: any) {
            return InternalMonitoringApiFp(configuration).disableMonitoring(DisableMonitoringRequest, options)(fetch, basePath);
        },
        /**
         * Returns all companies that have monitoring configuration. This endpoint provides a list of companies with active monitoring setup.
         * @summary get all companies with monitoring
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCompaniesWithMonitoring(options?: any) {
            return InternalMonitoringApiFp(configuration).getAllCompaniesWithMonitoring(options)(fetch, basePath);
        },
        /**
         * Returns the current customer report containing health status of all monitored services. This endpoint provides a comprehensive overview of system health including API gateway status, file system worker status, queue status, and other critical service metrics.
         * @summary get customer report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerReport(options?: any) {
            return InternalMonitoringApiFp(configuration).getCustomerReport(options)(fetch, basePath);
        },
        /**
         * Returns the customer report filtered for Icinga monitoring system. This endpoint excludes companies that are marked as ignored in the monitoring configuration.
         * @summary get customer report filtered for Icinga
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerReportFilteredForIcinga(options?: any) {
            return InternalMonitoringApiFp(configuration).getCustomerReportFilteredForIcinga(options)(fetch, basePath);
        },
        /**
         * Returns the customer report filtered to show only data for the authenticated user's company. This endpoint provides company-specific monitoring data based on the user's authentication context.
         * @summary get customer report for my company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerReportForMyCompany(options?: any) {
            return InternalMonitoringApiFp(configuration).getCustomerReportForMyCompany(options)(fetch, basePath);
        },
        /**
         * Returns all monitoring records (history) for a specific company. This endpoint provides a complete audit trail of monitoring actions.
         * @summary get monitoring records for company
         * @param {string} companyId companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonitoringRecordsForCompany(companyId: string, options?: any) {
            return InternalMonitoringApiFp(configuration).getMonitoringRecordsForCompany(companyId, options)(fetch, basePath);
        },
        /**
         * Returns the current monitoring status for all services of a specific company. This endpoint provides a comprehensive view of monitoring state for a company.
         * @summary get monitoring status for company
         * @param {string} companyId companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonitoringStatusForCompany(companyId: string, options?: any) {
            return InternalMonitoringApiFp(configuration).getMonitoringStatusForCompany(companyId, options)(fetch, basePath);
        },
        /**
         * Returns a specific section of the customer report based on the report type. Available report types: apiGatewayStatus, fileSystemWorkerStatus, queueStatus,  statusJsonReport, needsVerificationFilesCount, errorFilesCount, etaCalculatorHealth,  messageLogHealth, schedulerReportTaskStatus.
         * @summary get specific customer report section
         * @param {string} specificReport specificReport
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpecificCustomerReport(specificReport: string, options?: any) {
            return InternalMonitoringApiFp(configuration).getSpecificCustomerReport(specificReport, options)(fetch, basePath);
        },
        /**
         * Returns only unhealthy companies that are not ignored for Icinga monitoring. This endpoint provides a focused view of companies requiring attention.
         * @summary get unhealthy companies for Icinga
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnhealthyCompaniesForIcinga(options?: any) {
            return InternalMonitoringApiFp(configuration).getUnhealthyCompaniesForIcinga(options)(fetch, basePath);
        },
        /**
         * Returns the customer report after performing a fresh health check. This endpoint triggers a health check before returning the report, ensuring the most current status.
         * @summary get updated customer report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUpdatedCustomerReport(options?: any) {
            return InternalMonitoringApiFp(configuration).getUpdatedCustomerReport(options)(fetch, basePath);
        },
        /**
         * Processes all \"until change\" conditions for active monitoring records. This endpoint checks if any monitoring records should be disabled based on change detection logic and disables them automatically.
         * @summary process until change conditions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processUntilChangeConditions(options?: any) {
            return InternalMonitoringApiFp(configuration).processUntilChangeConditions(options)(fetch, basePath);
        },
    };
};

/**
 * InternalMonitoringApi - object-oriented interface
 * @export
 * @class InternalMonitoringApi
 * @extends {BaseAPI}
 */
export class InternalMonitoringApi extends BaseAPI {
    /**
     * Adds monitoring records for multiple companies and a single service type. This endpoint allows acknowledging or ignoring monitoring alerts for specific services. Supports both single company (list with one item) and multiple companies.
     * @summary add monitoring record
     * @param {MonitoringRecordRequest} MonitoringRecordRequest MonitoringRecordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalMonitoringApi
     */
    public addMonitoringRecord(MonitoringRecordRequest: MonitoringRecordRequest, options?: any) {
        return InternalMonitoringApiFp(this.configuration).addMonitoringRecord(MonitoringRecordRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Disables monitoring for multiple companies and a single service type. This endpoint allows unacknowledging or unignoring monitoring alerts. Supports both single company (list with one item) and multiple companies.
     * @summary disable monitoring
     * @param {DisableMonitoringRequest} DisableMonitoringRequest DisableMonitoringRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalMonitoringApi
     */
    public disableMonitoring(DisableMonitoringRequest: DisableMonitoringRequest, options?: any) {
        return InternalMonitoringApiFp(this.configuration).disableMonitoring(DisableMonitoringRequest, options)(this.fetch, this.basePath);
    }

    /**
     * Returns all companies that have monitoring configuration. This endpoint provides a list of companies with active monitoring setup.
     * @summary get all companies with monitoring
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalMonitoringApi
     */
    public getAllCompaniesWithMonitoring(options?: any) {
        return InternalMonitoringApiFp(this.configuration).getAllCompaniesWithMonitoring(options)(this.fetch, this.basePath);
    }

    /**
     * Returns the current customer report containing health status of all monitored services. This endpoint provides a comprehensive overview of system health including API gateway status, file system worker status, queue status, and other critical service metrics.
     * @summary get customer report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalMonitoringApi
     */
    public getCustomerReport(options?: any) {
        return InternalMonitoringApiFp(this.configuration).getCustomerReport(options)(this.fetch, this.basePath);
    }

    /**
     * Returns the customer report filtered for Icinga monitoring system. This endpoint excludes companies that are marked as ignored in the monitoring configuration.
     * @summary get customer report filtered for Icinga
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalMonitoringApi
     */
    public getCustomerReportFilteredForIcinga(options?: any) {
        return InternalMonitoringApiFp(this.configuration).getCustomerReportFilteredForIcinga(options)(this.fetch, this.basePath);
    }

    /**
     * Returns the customer report filtered to show only data for the authenticated user's company. This endpoint provides company-specific monitoring data based on the user's authentication context.
     * @summary get customer report for my company
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalMonitoringApi
     */
    public getCustomerReportForMyCompany(options?: any) {
        return InternalMonitoringApiFp(this.configuration).getCustomerReportForMyCompany(options)(this.fetch, this.basePath);
    }

    /**
     * Returns all monitoring records (history) for a specific company. This endpoint provides a complete audit trail of monitoring actions.
     * @summary get monitoring records for company
     * @param {string} companyId companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalMonitoringApi
     */
    public getMonitoringRecordsForCompany(companyId: string, options?: any) {
        return InternalMonitoringApiFp(this.configuration).getMonitoringRecordsForCompany(companyId, options)(this.fetch, this.basePath);
    }

    /**
     * Returns the current monitoring status for all services of a specific company. This endpoint provides a comprehensive view of monitoring state for a company.
     * @summary get monitoring status for company
     * @param {string} companyId companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalMonitoringApi
     */
    public getMonitoringStatusForCompany(companyId: string, options?: any) {
        return InternalMonitoringApiFp(this.configuration).getMonitoringStatusForCompany(companyId, options)(this.fetch, this.basePath);
    }

    /**
     * Returns a specific section of the customer report based on the report type. Available report types: apiGatewayStatus, fileSystemWorkerStatus, queueStatus,  statusJsonReport, needsVerificationFilesCount, errorFilesCount, etaCalculatorHealth,  messageLogHealth, schedulerReportTaskStatus.
     * @summary get specific customer report section
     * @param {string} specificReport specificReport
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalMonitoringApi
     */
    public getSpecificCustomerReport(specificReport: string, options?: any) {
        return InternalMonitoringApiFp(this.configuration).getSpecificCustomerReport(specificReport, options)(this.fetch, this.basePath);
    }

    /**
     * Returns only unhealthy companies that are not ignored for Icinga monitoring. This endpoint provides a focused view of companies requiring attention.
     * @summary get unhealthy companies for Icinga
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalMonitoringApi
     */
    public getUnhealthyCompaniesForIcinga(options?: any) {
        return InternalMonitoringApiFp(this.configuration).getUnhealthyCompaniesForIcinga(options)(this.fetch, this.basePath);
    }

    /**
     * Returns the customer report after performing a fresh health check. This endpoint triggers a health check before returning the report, ensuring the most current status.
     * @summary get updated customer report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalMonitoringApi
     */
    public getUpdatedCustomerReport(options?: any) {
        return InternalMonitoringApiFp(this.configuration).getUpdatedCustomerReport(options)(this.fetch, this.basePath);
    }

    /**
     * Processes all \"until change\" conditions for active monitoring records. This endpoint checks if any monitoring records should be disabled based on change detection logic and disables them automatically.
     * @summary process until change conditions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalMonitoringApi
     */
    public processUntilChangeConditions(options?: any) {
        return InternalMonitoringApiFp(this.configuration).processUntilChangeConditions(options)(this.fetch, this.basePath);
    }

}

